module.exports = __webpack_public_path__ + "img/小组课@2x.68000384.png";